import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { type RichTreeViewProProps, RichTreeViewProRoot } from "@mui/x-tree-view-pro";
import React, { forwardRef, HTMLAttributes, ReactNode } from "react";
import { RateBuilderBottomToolbar } from "../RateTreeItem/RateBuilderBottomToolbar";
import { CrossroadBadge } from "./components/CrossroadBadge";

import { RateBuilderTreeViewItem } from "@sinch/components/application/RatelistBuilder/types";
import { useRateBuilderSettings } from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";

export const RateBuilderTreeRoot = forwardRef(
  (
    {
      rootToolbar,
      ...props
    }: HTMLAttributes<HTMLUListElement> & {
      ownerState: RichTreeViewProProps<RateBuilderTreeViewItem, false>;
      rootToolbar: ReactNode;
    },
    ref: React.Ref<HTMLUListElement>
  ) => {
    const { mode } = useRateBuilderSettings();

    return (
      <RateBuilderTreeRootWrapper ref={ref} {...props}>
        <CrossroadBadge
          sx={(theme) => ({
            top: "0px",
            zIndex: 1,
            backgroundColor: theme.palette.grey[400],
          })}
        ></CrossroadBadge>
        {props.children}
        {mode === "edit" && (
          <RateBuilderBottomToolbar elseToolbar={false} isWrapped={false} sx={{ marginLeft: "0px" }}>
            {rootToolbar}
          </RateBuilderBottomToolbar>
        )}
      </RateBuilderTreeRootWrapper>
    );
  }
);
RateBuilderTreeRoot.displayName = "RateBuilderRoot";

export const RateBuilderTreeRootWrapper = styled(RichTreeViewProRoot)<BoxProps<"ul">>(({ theme }) => ({
  paddingTop: theme.spacing(1),
}));
